import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const getUnitDetailsList = createAsyncThunk("units/getUnitDetailsList", async ({ channelId, filters, page, limit }, { rejectWithValue }) => {
	const queryParams = new URLSearchParams({
		page: page,
		limit: limit,
		keyword: filters?.keyword ?? "",
	});

	try {
		const response = await axiosHttp.get(`channel/${channelId}/unitDetails?${queryParams}`);
		return response.data;
	} catch (error) {
		return rejectWithValue(error.response?.data || "An error occurred");
	}
});

const UnitDetailsListSlice = createSlice({
	name: "unitDetails",
	initialState: {
		unitDetails: [],
		isLoading: false,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder
			.addCase(getUnitDetailsList.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(getUnitDetailsList.fulfilled, (state, action) => {
				state.isLoading = false;
				state.unitDetails = action.payload;
				state.page = action.payload.page;
				state.total = action.payload.total;
			})
			.addCase(getUnitDetailsList.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload || "Failed to fetch unit details.";
			});
	},
});

export const { resetUnitDetailsListState } = UnitDetailsListSlice.actions;
export default UnitDetailsListSlice.reducer;
